export interface Player {
  id: string;
  name: string;
  email: string;
  phone?: string;
  interest?: string;
  company: string;
}

const PLAYER_SESSION_KEY = 'aws-memory-game-player';
const ICON_CACHE_KEY = 'aws-memory-game-icon-cache';

// Player functions using session storage
export const savePlayer = (player: Player): void => {
  sessionStorage.setItem(PLAYER_SESSION_KEY, JSON.stringify(player));
};

export const getPlayer = (): Player | null => {
  const playerJson = sessionStorage.getItem(PLAYER_SESSION_KEY);
  if (!playerJson) return null;
  
  try {
    return JSON.parse(playerJson);
  } catch {
    return null;
  }
};

export const clearPlayer = (): void => {
  sessionStorage.removeItem(PLAYER_SESSION_KEY);
};

// Icon cache functions using local storage
export const saveIconCache = (iconCache: { [key: string]: string }): void => {
  localStorage.setItem(ICON_CACHE_KEY, JSON.stringify(iconCache));
};

export const getIconCache = (): { [key: string]: string } => {
  const cacheJson = localStorage.getItem(ICON_CACHE_KEY);
  if (!cacheJson) return {};
  
  try {
    return JSON.parse(cacheJson);
  } catch {
    return {};
  }
};

export const clearIconCache = (): void => {
  localStorage.removeItem(ICON_CACHE_KEY);
}; 